import { MessageSquareWarning } from 'lucide-react';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

type NoteIndicatorProps = {
  note: string;
};

export const NoteIndicator = (props: NoteIndicatorProps) => {
  const { note } = props;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <span className="text-muted-foreground flex max-w-xs items-center gap-1.5 text-xs">
          <MessageSquareWarning className="text-warning-soft-foreground size-4 shrink-0" />
          <span className="line-clamp-1 min-w-24 break-all">{note}</span>
        </span>
      </TooltipTrigger>
      <TooltipContent className="max-w-80 whitespace-pre-wrap">
        {note}
      </TooltipContent>
    </Tooltip>
  );
};
